import { Injectable, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { Breadcrumbs } from "../../models/cms/breadcrumbs";

import { RoutesService } from "../core/routes.service";
import { LanguageService } from "../cms/language.service";


@Injectable()
export class BreadcrumbsService {

    protected breadcrumbsList: Breadcrumbs[];

    private homeIsInit: boolean = false;
    constructor(protected router: Router,
        private languageService: LanguageService,
        private translateService: TranslateService,
        @Inject('isBrowser') private isBrowser: boolean, ) {
    }


    setHomeBreadcrumb() {
        if (this.breadcrumbsList != null && this.breadcrumbsList.length > 0) {
            if (this.breadcrumbsList[0].Level == 0) {
                return;
            }
        }

        let lang: string = this.languageService.getShortLang();
        let homeLink = "/home";
        if (lang != null && lang != "") {
            homeLink = lang + homeLink;
        }
        else {
            homeLink = homeLink;
        }

        var bread = new Breadcrumbs();

        bread.BreadcrumbLink = homeLink;
        bread.BreadcrumbName = this.translateService.get("home_area_message_home")["value"];
        bread.Level = 0;

        this.breadcrumbsList.unshift(bread);
        this.homeIsInit = true;
    }


    setBreadcrumbs(breadcrumbs: Breadcrumbs[], type?: string) {
        this.breadcrumbsList = [];

        if (type != "cmspage") {
            if (breadcrumbs != null && breadcrumbs.length > 0) {
                breadcrumbs.forEach(x => {
                    x.BreadcrumbLink = x.BreadcrumbLink.toLocaleLowerCase();
                });
            }
        }

        this.breadcrumbsList = breadcrumbs;
        // this.setHomeBreadcrumb();
    }

    getBreadcrumbs() {
        var breadcrumbs = this.breadcrumbsList;

        return breadcrumbs;
    }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/services/cms/breadcrumbs.service.ts